<button type="button"
  class="btn d-flex justify-content-between w-100 {{ isDisabled ? 'disabled' : '' }}"
  (click)="toggle()" ngbTooltip="Click to toggle Yes/No">
  <span class="icon {{ localValue?.toLocaleLowerCase() == 'no' ? 'off' : 'on' }}"><i
      class="bi {{ localValue?.toLocaleLowerCase() == 'no' ? 'bi-toggle2-off' : 'bi-toggle2-on' }}"></i></span>
  <div class="inner d-flex justify-content-between w-100">
    <span class="text-gray-600"
      *ngIf="localValue?.toLocaleLowerCase() != 'no' && localValue?.toLocaleLowerCase() != 'yes'">{{ title }}</span>
    <span *ngIf="localValue?.toLocaleLowerCase() != 'no' || localValue?.toLocaleLowerCase() != 'yes'"
      class="text-dark">{{ localValue | uppercase }}</span>
    <span>
      <span class="ms-2">
        <i class="bi bi-arrow-down-up fw-bold"></i>
      </span>
    </span>
  </div>
</button>
